import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import "./app.scss";
import { Provider } from "mobx-react";
import store from "../store";

import Entry from "pages/entry";
import Guide from "pages/guide";
import Index from "pages/index";
import Preferential from "pages/preferential";
import EducationTraining from "pages/educationTraining";
import Login from "pages/login";
import Register from "pages/register";
import Find from "pages/password/find";
import Step from "pages/password/step";
import Reset from "pages/password/reset";
import Success from "pages/password/success";
import Home from "pages/home";
import sso from "pages/login/sso";
import logout from "pages/login/logout";
import xfapplication from "pages/xfapplication";

import Policy from "pages/policy";
import Exchange from "pages/exchange";
import Comminicate from "pages/comminicate";
import PolicyDetails from "pages/policy/details";
import Information from "pages/information";
// import InformationDetails from 'pages/information/details';
import NotFound from "pages/notfound/404.js";
// 政务服务
import GovernmentService from "pages/governmentService";
// 优惠服务
import PreferentialProducts from "pages/preferentialProducts";
// 产品详情
import ProductsDetail2 from "pages/preferentialProducts/detail2";

import PreferentialProductsList from "pages/preferentialProducts/products";
import ProductsDetail from "pages/preferentialProducts/detail";
//便民服务
import convenience from "pages/convenience";
// 搜索
import SearchResult from "pages/searchResult";
// 地图
import Map from "pages/map";

import Search from "pages/preferential/search";
import Personal from "pages/userCenter/personal";
// import ServiceProvider from 'pages/userCenter/serviceProvider';
import Application from "pages/preferential/application";
import PreferentialDetail from "pages/preferential/preferentialDetail";
import PreferentialInfo from "pages/preferential/preferentialInfo";

import PreferentialPolicy from "pages/preferential/preferentialPolicy";
import PreferentialPolicyDetail from "pages/preferential/preferentialPolicyDetail";
import PreferentialInformationDetail from "pages/preferential/preferentialInformationDetail";
import ApplicationProcess from "pages/preferential/applicationProcess";
import ApplicationGuide from "pages/preferential/applicationGuide";
import DeucationTrainingInfoDetail from "pages/educationTraining/deucationTrainingDetail";
import DeucationTrainingInfo from "pages/educationTraining/deucationTrainingInfo";
import DeucationTrainingPolicy from "pages/educationTraining/deucationTrainingPolicy";
import DeucationTrainingPolicyDetail from "pages/educationTraining/deucationTrainingPolicyDetail";
import EducationTrainingOrganization from "pages/educationTraining/educationTrainingOrganization";
import EduOrganizationDetail from "pages/educationTraining/eduOrganizationDetail";

import Soldier from "pages/soldier";
import AboutUs from "pages/aboutUs";
import SoldierDetail from "pages/soldier/soldierDetail";

import qyprotection from "pages/qyprotection";
import lifeCycle from "pages/lifeCycle";
import modelcity from "pages/modelCity";

import workservice from "pages/workService";

import main from "pages/main";
import complaint from "pages/complaint";
// 服务中心
import ServiceCenter from "pages/serviceCenter";
import customService from "pages/customService";

// 教育培训
import educationTraining from "pages/educationTraining/educationTraining";
import Result from "pages/educationTraining/result";
import ResultDetail from "pages/educationTraining/resultDetail";
import TrainingApplication from "pages/educationTraining/trainingApplication";
import TrainingGuide from "pages/educationTraining/trainingGuide";
import TrainingHandle from "pages/educationTraining/trainingHandle";
import TextSearch from "pages/textSearch";

//互动交流
import opinionsMailbox from "pages/comminicate/opinionsMailbox"; //网上征求意见信箱
import businessConsulting from "pages/comminicate/businessConsulting"; //业务咨询
import directorMailbox from "pages/comminicate/directorMailbox"; //厅长信箱
import solicitOpinions from "pages/comminicate/solicitOpinions"; //征求意见

import opinionsMailboxDetail from "pages/comminicate/opinionsMailboxDetail"; //网上征求意见信箱
import businessConsultingDetail from "pages/comminicate/businessConsultingDetail"; //业务咨询
import directorMailboxDetail from "pages/comminicate/directorMailboxDetail"; //厅长信箱
import solicitOpinionsDetail from "pages/comminicate/solicitOpinionsDetail"; //征求意见
import map from "pages/map";

import mobileguide from "pages/mobileguide"; //移动端

//个人中心模块-信息详情页
// import InformationDetails from "pages/userCenter/personal/informationDetails";

function AppRouter() {
  let routerConfig = [
    { path: "/sso", title: "单点登录处理", exact: false, component: sso },
    { path: "/logout", title: "退出", exact: false, component: logout },
    { path: "/entry", title: "引导页原版", exact: false, component: Entry },
    // { path: '/', title: '引导页', exact: true, component: Guide },
    // { path: '/', title: '引导页', exact: true, component: Home },
    { path: "/login", title: "登录", exact: false, component: Login },
    { path: "/register", title: "注册", exact: false, component: Register },
    { path: "/find", title: "找回密码", exact: false, component: Find },
    {
      path: "/step",
      title: "找回密码-验证手机号",
      exact: false,
      component: Step,
    },
    {
      path: "/reset",
      title: "找回密码-修改密码",
      exact: false,
      component: Reset,
    },
    {
      path: "/success",
      title: "找回密码-修改成功",
      exact: false,
      component: Success,
    },
    { path: "/entrance", title: "主页", exact: false, component: Index },
    {
      path: "/preferential",
      title: "优抚优待",
      exact: false,
      component: Preferential,
    },
    {
      path: "/educationTraining",
      title: "教育培训",
      exact: false,
      component: EducationTraining,
    },
    { path: "/content", title: "引导页", exact: true, component: Home },
    // {
    //   path: "/entrance/personal/informationDetails",
    //   title: "信息详情",
    //   exact: true,
    //   component: InformationDetails,
    // },
    // { path: '/xfapplication', title: '信访信息申请', component: xfapplication },
    // { path: '/map', title: '地图', component: map },
    // { path: '/mobileguide', title:'办事指南',component:mobileguide}
  ];
  const prefix = "";
  return (
    <Provider store={store}>
      <Router basename="/">
        <Switch>
          {routerConfig.map((item, index) => {
            return (
              <Route
                key={index}
                path={prefix + item.path}
                exact={item.exact}
                component={item.component}
              />
            );
          })}

          <Redirect from="/*" to={`${prefix}/entrance`} />
        </Switch>
      </Router>
    </Provider>
  );
}

export default AppRouter;
